import { get, find, filter } from "lodash";
import { BreadCrumb } from "primereact/breadcrumb";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FilterTags } from "components/FilterTags";
import { Link } from "react-router-dom";
import { PageRequestError } from "components/PageRequestError";
import { Paginator } from "primereact/paginator";
import useApp from "hooks/useApp";
import useApi from "hooks/useApi";
import useAuth from "hooks/useAuth";
import useListPage from "hooks/useListPage";
import { useTranslation } from 'react-i18next';
const AssignedMetrics = (props) => {
  const app = useApp();
  const api = useApi();
  const filterSchema = {
    search: {
      tagTitle: "Search",
      value: "",
      valueType: "single",
      options: [],
    },
  };
  const { t } = useTranslation();
  const auth = useAuth();
  const isSuperAdmin = auth.user.roleName === "Super Admin";
  const pageController = useListPage(props, filterSchema, "data");
  const filterController = pageController.filterController;
  const {
    records,
    pageReady,
    loading,
    sortBy,
    sortOrder,
    apiRequestError,
    getPageBreadCrumbs,
    onSort,
    deleteItem,
    pagination,
  } = pageController;
  const {} = filterController;
  const {
    totalRecords,
    totalPages,
    recordsPosition,
    firstRow,
    limit,
    onPageChange,
  } = pagination;
  async function updateMetric(metric, removedModuleId) {
    const updateMetric = {
      ...metric,
      modules: filter(
        get(metric, "modules", []),
        (moduleId) => moduleId !== removedModuleId
      ),
    };
    return api
      .put("metrics/edit_metrics" + "/" + metric.id, updateMetric)
      .then((res) => {
        const latestCounter = props.updateCounter + 1;
        props.setUpdateCounter(latestCounter);
      });
  }
  function ActionButton(data) {
    return (
      <i
        className="pi pi-times"
        style={{
          cursor: "pointer",
          color: "var(--red-500)",
        }}
        onClick={() =>
          deleteItem(
            data.id,
            "metrics/remove_metrics",
            updateMetric.bind(null, data, props.recId)
          )
        }
      />
    );
  }
  function IdTemplate(data) {
   
    if (data) {
      return <Link to={`/metrics/view/${data.id}`}> {data.id}</Link>;
    }
  }
  function MetricTypeTemplate(data) {
    let metricTypeLabel = "-";
    const metricTypes = get(app, "metricTypes", []);
    if (data && metricTypes.length > 0) {
      const metricType = find(
        metricTypes,
        (mType) => get(mType, "id") === get(data, "metric_type", null)
      );
      metricTypeLabel = metricType ? get(metricType, "label", "-") : "-";
    }
    return metricTypeLabel;
  }
  function EmptyRecordMessage() {
    if (pageReady && !records.length) {
      return (
        <div className="text-lg mt-3 p-3 text-center text-400 font-bold">
          {t("NO_METRICS_ASSIGNED")}
        </div>
      );
    }
  }
  function PagerControl() {
    if (props.paginate && totalPages > 1) {
      const pagerReportTemplate = {
        layout: pagination.layout,
        CurrentPageReport: (options) => {
          return (
            <>
              <span className="text-sm text-gray-500 px-2">
                {t("METRICS")}{" "}
                <b>
                  {recordsPosition} of {options.totalRecords}
                </b>
              </span>
            </>
          );
        },
      };
      return (
        <div className="flex-grow-1">
          <Paginator
            first={firstRow}
            rows={limit}
            totalRecords={totalRecords}
            onPageChange={onPageChange}
            template={pagerReportTemplate}
          />
        </div>
      );
    }
  }
  function PageFooter() {
    if (pageReady && props.showFooter) {
      return (
        <div className="flex flex-wrap justify-content-between">
          <PagerControl />
        </div>
      );
    }
  }
  function PageBreadcrumbs() {
    if (props.showBreadcrumbs) {
      const items = getPageBreadCrumbs();
      return items.length > 0 && <BreadCrumb className="mb-3" model={items} />;
    }
  }
  if (apiRequestError) {
    return <PageRequestError error={apiRequestError} />;
  }
  return (
    <main
      id="AssignedMetrics"
      className="main-page"
      style={{
        width: "100%",
      }}
    >
      <section className="page-section ">
        <div className="container-fluid">
          <div className="grid ">
            <div className="col comp-grid">
              <FilterTags filterController={filterController} />
              <div>
                <PageBreadcrumbs />
                <div className="page-records">
                  <DataTable
                    lazy={true}
                    loading={loading}
                    value={records}
                    dataKey="id"
                    sortField={sortBy}
                    sortOrder={sortOrder}
                    onSort={onSort}
                    className=" p-datatable-sm"
                    // stripedRows={true}
                    showGridlines={false}
                    rowHover={true}
                    responsiveLayout="stack"
                    emptyMessage={<EmptyRecordMessage />}
                  >
                    <Column field="id" header="Id" body={isSuperAdmin ? IdTemplate : null}></Column>
                    <Column field="name" header={t('NAME')}></Column>
                    <Column
                      field="metric_type"
                      header={t("METRIC_TYPE")}
                      body={MetricTypeTemplate}
                    ></Column>
                    <Column field="position" header={t("POSITION")}></Column>
                    <Column field="status" header={t("STATUS")}></Column>
                    <Column
                      headerStyle={{ width: "2rem" }}
                      headerClass="text-center"
                      body={ActionButton}
                    ></Column>
                  </DataTable>
                </div>
                <PageFooter />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
const withDefaultProps = (Component) => {
  const WrappedComponent = (props) => {
    const { t } = useTranslation();
    const defaultProps = {
  primaryKey: "id",
  pageName: "assignedMetrics",
  apiPath: "metrics/get_metrics_by_module",
  routeName: "assignedmetrics",
  msgBeforeDelete: "Are you sure you want to remove this Metric from Module?",
  msgTitle: "Remove Metric",
  msgAfterDelete: "Metric removed successfully",
  showHeader: true,
  showFooter: true,
  paginate: true,
  isSubPage: false,
  showBreadcrumbs: true,
  exportData: false,
  importData: false,
  keepRecords: false,
  multiCheckbox: true,
  search: "",
  fieldName: null,
  fieldValue: null,
  sortField: "",
  sortDir: "",
  pageNo: 1,
  limit: 10,
};
return <Component {...defaultProps} {...props} />;
  };

  return WrappedComponent;
};
export default withDefaultProps(AssignedMetrics);
